import { useEffect, useState } from "react"
import eagleRepository from "./EagleRepository"

export function useEagle(solicitacaoId) {
  const [initialLoading, setInitialLoading] = useState(true)
  const [eagle, setEagle] = useState(null)
  const [message, setMessage] = useState('')
  const [creating, setCreating] = useState(false)


  const handleCreate = async () => {
    setCreating(true)
    const result = await eagleRepository.create(solicitacaoId)
    setCreating(false)

    if (!result.ok) {
      const resultGet = await eagleRepository.fetch(solicitacaoId)
      return setEagle(resultGet.data)
    }

    setEagle(result.data)
  }

  const handleRecreate = async () => {
    const result = await eagleRepository.recreate(solicitacaoId)

    if (!result.ok) {
      const resultGet = await eagleRepository.fetch(solicitacaoId)
      return setEagle(resultGet.data)
    }

    setEagle(result.data)
  }


  const handleRecreateNewQuery = async () => {
    setCreating(true)
    const result = await eagleRepository.recreateNewConsult(solicitacaoId)
    setCreating(false)

    if (!result.ok) {
      const resultGet = await eagleRepository.fetch(solicitacaoId)
      return setEagle(resultGet.data)
    }

    setEagle(result.data)
  }

  const handleRefreshFromDb = async () => {
    const result = await eagleRepository.fetch(solicitacaoId)

    if (!result.ok) {
      setMessage(result?.data?.message || "Ocorreu um erro, tente novamente")
    }

    setEagle(result.data)
  }

  const handleRefresh = async () => {
    const result = await eagleRepository.refreshResult(solicitacaoId)

    if (!result.ok) {
      setMessage(result?.data?.message || "Ocorreu um erro, tente novamente")
    }

    setEagle(result.data)
  }
  function clearMessage() {
    setMessage('')
  }
  

  useEffect(() => {
    const getData = async () => {
      setInitialLoading(true)
      
      try {
        const result = await eagleRepository.fetch(solicitacaoId)
        if (!result.ok) {
          setMessage(result.data.message)
        }

        setEagle(result.data)
      } finally {

        setInitialLoading(false)
      }
    }

    getData()
  }, [solicitacaoId])

  return {
    initialLoading,
    eagle,
    message,
    clearMessage,
    creating,
    handleCreate,
    handleRecreate,
    handleRefreshFromDb,
    handleRecreateNewQuery,
    handleRefresh
  }
}